module.exports = __webpack_public_path__ + "img/no-search-result.1b19d600.svg";